/**
 * Prepares items to be cancelled by calling the booking API's Order modification endpoint and setting their status to 700
 * @param orderId string
 */
function cancelAndRefund(orderId) {
    console.log(orderId);
    return fetch('/wp-json/xola/v1/cancel-refund', {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            body: 'orderId=' + orderId
        }
    )
        .then((response) => response.json())
    // return true
}